import { defineStore } from 'pinia'
import { ComponentStatus, ComponentLoadStatus } from './types'

interface ComponentStateStore {
    components: Record<string, ComponentStatus>;
}

export const useComponentStore = defineStore('componentStatus', {
    // 状态定义  
    state: (): ComponentStateStore => ({
        components: {}
    }),

    // 计算属性  
    getters: {
        // 获取所有组件状态  
        getAllComponentStatuses(): Record<string, ComponentStatus> {
            return this.components
        },

        // 检查特定组件是否已加载  
        isComponentLoaded(): (componentId: string) => boolean {
            return (componentId: string) => {
                return this.components[componentId]?.isLoaded || false
            }
        }
    },

    // 操作方法  
    actions: {
        // 注册组件  
        registerComponent(componentId: string, initialData?: any) {
            if (!this.components[componentId]) {
                this.components[componentId] = {
                    id: componentId,
                    isLoaded: false,
                    data: initialData,
                    timestamp: Date.now()
                }
            }
        },

        // 标记组件为加载中  
        setComponentLoading(componentId: string) {
            if (this.components[componentId]) {
                this.components[componentId].isLoaded = false
            }
        },

        // 标记组件已加载  
        setComponentLoaded(componentId: string, data?: any) {
            if (!this.components[componentId]) {
                // 如果组件未注册,先进行注册
                this.registerComponent(componentId)
            }

            this.components[componentId].isLoaded = true
            this.components[componentId].data = data
            this.components[componentId].timestamp = Date.now()
        },

        // 标记组件加载错误  
        setComponentError(componentId: string, error?: any) {
            if (this.components[componentId]) {
                this.components[componentId].isLoaded = false
                this.components[componentId].data = error
            }
        },

        // 获取组件状态  
        getComponentStatus(componentId: string): ComponentStatus | undefined {
            return this.components[componentId]
        },

        // 重置特定组件状态  
        resetComponentStatus(componentId: string) {
            delete this.components[componentId]
        },

        // 清除所有组件状态  
        clearAllComponentStatuses() {
            this.components = {}
        }
    }
})